import src from "IMAGE";
export default { src, width: 1920, height: 1080, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAMElEQVR42n3KoQ0AMAwDwew/XwxseZdUCiqoCw689GV7fuoOSSsOAAbdeSC54vByAPbNjq+A+6ldAAAAAElFTkSuQmCC"};
